<body>
  <app-nav-menu *ngIf="!isFullscreenRoute"></app-nav-menu>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
 <app-device-list *ngIf="isFullscreenRoute"></app-device-list>
</body>
